
import { initEnv } from '@tencent/pmd-tools/lib/env';
import { post } from '@tencent/pmd-network';
import { UNDER_AGE_IMAGE_MAP } from '../wx-image/config';
import CommTipsDialog from '@tencent/press-ui/press-dialog';
import { saveImage } from '../wx-image/wx-image';

/**
 * 获取用户是否关注公众号
 * @param options
 *            showMsgToast: 是否显示错误toast
 */
export function getUserInfo(options) {
  return new Promise((resolve, reject) => {
    const reqData = {
      apptype: initEnv().isQQ ? 1 : 0,
    };
    post({
      url: '/pvpesport.sgamenes.commcgi.commcgi/GetUserInfo',
      reqData,
      showMsgToast: (options && options.showMsgToast) || false,
    })
      .then((response) => {
        const result = {
          subscribe: false,
        };
        if (response.r == 0) {
          if (response.user_info) {
            result.subscribe = response.user_info.subscribe == 1 || response.user_info.qqSubscribe == 1;
            if (result.subscribe) {
              // 关注了公众号
              window.sessionStorage.setItem('user-is-subscribe-offical-account', '1');
            } else {
              window.sessionStorage.setItem('user-is-subscribe-offical-account', '2');
            }
            app?.$ebus?.emit('event-user-info', response.user_info);
          }
        }
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function checkAutoShowOfficialDialog(popId, dialogProps) {
  if ((app.env.isWeixin || app.env.isQQ || app.env.isMiniProgram) && window.sessionStorage.getItem('user-is-subscribe-offical-account') !== '1') {
    autoPopCount(popId, dialogProps);
  }
}

/**
 * 查询用户注册信息
 * @returns {Promise<unknown>}
 */
export function queryMemberInfo() {
  return new Promise((resolve, reject) => {
    post({
      url: '/pvpesport.sgamenes.nesplayer.nesplayer/QueryMemberInfo',
      showMsgToast: false,
    }).then((response) => {
      if (response.mem_info && Object.keys(response.mem_info).length > 0) {
        resolve(response.mem_info);
      } else {
        reject({});
      }
    })
      .catch((err) => {
        reject(err);
      });
  });
}

/**
 * 显示成年人认证弹窗
 */
export function showNonageDialog() {
  const env = initEnv();
  const src = env.isQQ ? UNDER_AGE_IMAGE_MAP.QQ : UNDER_AGE_IMAGE_MAP.WX;

  CommTipsDialog.show({
    title: '未成年无法参赛',
    content: '您在成长守护平台状态是未成年，请前往「腾讯成长守护」公众号认证。',
    src,
    canTouchRemove: true,
    cancelText: '关闭',
    confirmText: '重试',
    lightbtn: true,
    // #ifdef MP-QQ
    onLongPressImage: saveImage.bind(null, src),
    // #endif
  })
    .then(() => {
      window.location.reload();
    })
    .catch(() => {
    });
}

function autoPopCount(popId, dialogProps) {
  if ((app.env.isWeixin || app.env.isQQ) && window.sessionStorage.getItem('user-is-subscribe-offical-account') !== '1') {
    getAutoPopCount(popId)
      .then((res) => {
        console.log('getAutoPopCount res', res);
        if (res.r === 0
          && !res.count
          && window.sessionStorage.getItem('user-is-subscribe-offical-account') === '2') {
          // 真正查到未关注公众号才弹窗
          app.$ebus.emit('show-weixin-official-dialog', dialogProps);
          setAutoPopCount(popId);
        }
      })
      .catch((err) => {
        console.log('getAutoPopCount err', err);
      });
  }
}


/**
 * 通用弹窗计数查询
 */
function getAutoPopCount(popId) {
  return post({
    url: '/pvpesport.sgamenes.commcgi.commcgi/QueryCommPopCount',
    reqData: {
      confg_id: 'pvpesport_pop',
      pop_id: popId,
    },
    showMsgToast: false,
  });
}

/**
 * 通用弹窗计数查询
 */
function setAutoPopCount(popId) {
  return post({
    url: '/pvpesport.sgamenes.commcgi.commcgi/SetCommPopCount',
    reqData: {
      confg_id: 'pvpesport_pop',
      pop_id: popId,
    },
    showMsgToast: false,
  });
}
